export default "__VITE_ASSET__8wPk68MB__"